// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class FloorPhysicalOpeningsMessage implements flatbuffers.IUnpackableObject<FloorPhysicalOpeningsMessageT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): FloorPhysicalOpeningsMessage {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsFloorPhysicalOpeningsMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: FloorPhysicalOpeningsMessage,
  ): FloorPhysicalOpeningsMessage {
    return (obj || new FloorPhysicalOpeningsMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsFloorPhysicalOpeningsMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: FloorPhysicalOpeningsMessage,
  ): FloorPhysicalOpeningsMessage {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new FloorPhysicalOpeningsMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  frontOpenings(index: number): boolean | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? !!this.bb!.readInt8(this.bb!.__vector(this.bb_pos + offset) + index) : false;
  }

  frontOpeningsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  frontOpeningsArray(): Int8Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return new Int8Array(
      this.bb!.bytes().buffer,
      this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
      this.bb!.__vector_len(this.bb_pos + offset),
    );
  }

  rearOpenings(index: number): boolean | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? !!this.bb!.readInt8(this.bb!.__vector(this.bb_pos + offset) + index) : false;
  }

  rearOpeningsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  rearOpeningsArray(): Int8Array {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return new Int8Array(
      this.bb!.bytes().buffer,
      this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
      this.bb!.__vector_len(this.bb_pos + offset),
    );
  }

  static startFloorPhysicalOpeningsMessage(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addFrontOpenings(builder: flatbuffers.Builder, frontOpeningsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, frontOpeningsOffset, 0);
  }

  static createFrontOpeningsVector(
    builder: flatbuffers.Builder,
    data: boolean[],
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(+data[i]!);
    }
    return builder.endVector();
  }

  static startFrontOpeningsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addRearOpenings(builder: flatbuffers.Builder, rearOpeningsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, rearOpeningsOffset, 0);
  }

  static createRearOpeningsVector(
    builder: flatbuffers.Builder,
    data: boolean[],
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(+data[i]!);
    }
    return builder.endVector();
  }

  static startRearOpeningsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static endFloorPhysicalOpeningsMessage(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // front_openings
    builder.requiredField(offset, 6); // rear_openings
    return offset;
  }

  static createFloorPhysicalOpeningsMessage(
    builder: flatbuffers.Builder,
    frontOpeningsOffset: flatbuffers.Offset,
    rearOpeningsOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    FloorPhysicalOpeningsMessage.startFloorPhysicalOpeningsMessage(builder);
    FloorPhysicalOpeningsMessage.addFrontOpenings(builder, frontOpeningsOffset);
    FloorPhysicalOpeningsMessage.addRearOpenings(builder, rearOpeningsOffset);
    return FloorPhysicalOpeningsMessage.endFloorPhysicalOpeningsMessage(builder);
  }

  unpack(): FloorPhysicalOpeningsMessageT {
    return new FloorPhysicalOpeningsMessageT(
      this.bb!.createScalarList<boolean>(this.frontOpenings.bind(this), this.frontOpeningsLength()),
      this.bb!.createScalarList<boolean>(this.rearOpenings.bind(this), this.rearOpeningsLength()),
    );
  }

  unpackTo(_o: FloorPhysicalOpeningsMessageT): void {
    _o.frontOpenings = this.bb!.createScalarList<boolean>(
      this.frontOpenings.bind(this),
      this.frontOpeningsLength(),
    );
    _o.rearOpenings = this.bb!.createScalarList<boolean>(
      this.rearOpenings.bind(this),
      this.rearOpeningsLength(),
    );
  }

  unpackFields(...fields: string[]): FloorPhysicalOpeningsMessageT {
    const t = new FloorPhysicalOpeningsMessageT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("front_openings")) {
      t.frontOpenings = this.bb!.createScalarList<boolean>(
        this.frontOpenings.bind(this),
        this.frontOpeningsLength(),
      );
    }
    if (fieldSet.has("rear_openings")) {
      t.rearOpenings = this.bb!.createScalarList<boolean>(
        this.rearOpenings.bind(this),
        this.rearOpeningsLength(),
      );
    }
    return t;
  }
}

export class FloorPhysicalOpeningsMessageT implements flatbuffers.IGeneratedObject {
  constructor(
    public frontOpenings: boolean[] = [],
    public rearOpenings: boolean[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.frontOpenings === null || this.frontOpenings === undefined) {
      throw new Error('Required field "front_openings" is not set');
    }
    if (this.rearOpenings === null || this.rearOpenings === undefined) {
      throw new Error('Required field "rear_openings" is not set');
    }
    const frontOpenings = FloorPhysicalOpeningsMessage.createFrontOpeningsVector(
      builder,
      this.frontOpenings,
    );
    const rearOpenings = FloorPhysicalOpeningsMessage.createRearOpeningsVector(
      builder,
      this.rearOpenings,
    );

    return FloorPhysicalOpeningsMessage.createFloorPhysicalOpeningsMessage(
      builder,
      frontOpenings,
      rearOpenings,
    );
  }

  clone(): FloorPhysicalOpeningsMessageT {
    const obj = new FloorPhysicalOpeningsMessageT();
    obj.frontOpenings = [...this.frontOpenings];
    obj.rearOpenings = [...this.rearOpenings];
    return obj;
  }

  equals(other: FloorPhysicalOpeningsMessageT): boolean {
    if (this.frontOpenings.length !== other.frontOpenings.length) return false;
    for (let i = 0; i < this.frontOpenings.length; i++) {
      if (this.frontOpenings[i] !== other.frontOpenings[i]) return false;
    }
    if (this.rearOpenings.length !== other.rearOpenings.length) return false;
    for (let i = 0; i < this.rearOpenings.length; i++) {
      if (this.rearOpenings[i] !== other.rearOpenings[i]) return false;
    }
    return true;
  }
}

export function verifyFloorPhysicalOpeningsMessage(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "front_openings");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "rear_openings");
  } finally {
    verifier.popDepth();
  }
}
